import React from 'react';
import ContinentView from './ContinentView';

import banner from '../assets/asia.jpg';
import india from '../assets/india.jpg';
import japan from '../assets/japanNikkoKA6.jpg';

const destinations = [
  { name: 'India', region: 'India', image: india },
  { name: 'Japan', region: 'Japan', image: japan },
];

const Asia = () => (
  <ContinentView
    continentName="Asia"
    bannerImage={banner}
    description="Explore Asia with The Half Time Travel. Discover India, Japan, and other cultural destinations."
    destinations={destinations}
  />
);

export default Asia;